import { useContext } from 'react';

import { StepContext } from '../paymentStepProvider';

export const useStepContext = () => {
  const context = useContext(StepContext);

  if (!context) {
    throw new Error(
      'useStepContext должен быть использован внутри PaymentStepProvider',
    );
  }

  return context;
};
